import { RcFile } from 'antd/es/upload';
import axios from 'axios';
import { getISOWeek } from 'date-fns';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';
import jwt_decode from 'jwt-decode';
import { WorkShiftDay } from 'pages/workshift_calendar/[slug]';
dayjs.extend(weekday);
const getRowSpan = (date: Date, startDate: Date) => {
  const day = date.getDay() === 0 ? 7 : date.getDay();
  return date.getTime() === startDate.getTime() || day === 1
    ? 8 - day
    : undefined;
};

export const createFakeDate = (
  start: Date | undefined,
  end: Date | undefined,
) => {
  const tableData = [];
  if (start === undefined && end === undefined) return tableData;

  let currentDate = new Date(start);
  const startDate = new Date(currentDate);

  while (currentDate <= new Date(end)) {
    const fakeData = {
      name_day: dayjs(currentDate).format('ddd'),
      day: dayjs(currentDate).format('D'),
      month: dayjs(currentDate).format('M'),
      full_day: dayjs(currentDate).format('YYYY-MM-DD'),
      week: getISOWeek(currentDate),
      numberDateInWeek: getRowSpan(currentDate, startDate),
      dayInWeek: dayjs(currentDate).weekday(),
    };
    tableData.push(fakeData);
    currentDate.setUTCDate(currentDate.getUTCDate() + 1);
  }

  return tableData;
};

type tokenType = {
  exp: number;
  iat: number;
  id: number;
};
export async function checkTokenExpire(
  access_token: string,
  refresh_token: string,
) {
  const decodedToken: tokenType = jwt_decode(access_token);
  if (decodedToken.exp >= Date.now() / 1000) return;
  const res = await axios.post('/api/auth/refresh/', {
    refresh: refresh_token,
  });
  return res.data.access;
}
export function calculateTimeDifference(startTime, endTime) {
  if (startTime !== '' && endTime !== '') {
    const [startHours, startMinutes] = startTime?.split(':').map(Number);
    const [endHours, endMinutes] = endTime?.split(':').map(Number);

    let diffMinutes =
      endHours * 60 + endMinutes - (startHours * 60 + startMinutes);

    const diffHours = diffMinutes < 0 ? 0 : Math.floor(diffMinutes / 60);
    diffMinutes = diffMinutes % 60;

    const formattedDiff = `${diffHours}:${diffMinutes
      .toString()
      .padStart(2, '0')}`;

    if (diffMinutes < 0) {
      return '0';
    }
    return formattedDiff;
  } else {
    return '';
  }
}

export function calculatePlusTimeDifference(startTime, endTime) {
  if (startTime === '0' || endTime === '0') {
    return '0:00';
  } else {
    if (startTime !== '' && endTime !== '') {
      const [startHours, startMinutes] = startTime?.split(':').map(Number);

      const [endHours, endMinutes] = endTime?.split(':').map(Number);
      // console.log(endHours);
      let diffMinutes =
        endHours * 60 + endMinutes + (startHours * 60 + startMinutes);

      const diffHours =
        diffMinutes < 0
          ? Math.floor(diffMinutes / 60) + 1
          : Math.floor(diffMinutes / 60);
      diffMinutes = diffMinutes % 60;

      const formattedDiff = `${diffHours}:${diffMinutes
        .toString()
        .padStart(2, '0')}`;

      return formattedDiff;
    }
  }
}

export function totalPerWeek(data: WorkShiftDay[]): string {
  let totalMinutes = 0;

  const getDifferenceInMinutes = (
    startTime?: string,
    endTime?: string,
  ): number => {
    if (!startTime || !endTime) {
      return 0;
    }

    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const [endHours, endMinutes] = endTime.split(':').map(Number);

    return endHours * 60 + endMinutes - (startHours * 60 + startMinutes);
  };

  const getTotalMinutesPerWeek = (item: WorkShiftDay): number => {
    let totalMinutes = 0;

    if (item.workshift_2_active) {
      const diffMinutes = getDifferenceInMinutes(
        item.workshift_2_start_time,
        item.workshift_2_end_time,
      );
      totalMinutes += diffMinutes;
    }

    if (item.workshift_1_active) {
      const diffMinutes_1 = getDifferenceInMinutes(
        item.workshift_1_start_time,
        item.workshift_1_end_time,
      );
      totalMinutes += diffMinutes_1;
    }

    return totalMinutes;
  };
  data?.forEach((item: WorkShiftDay, index) => {
    if (item.workshift_1_active || item.workshift_2_active) {
      const diffMinutes = getTotalMinutesPerWeek(item);
      totalMinutes += diffMinutes;
    }
  });

  const diffHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  const formattedDiff = `${diffHours}:${remainingMinutes
    .toString()
    .padStart(2, '0')}`;

  return formattedDiff;
}

export function compareTimes(time1, time2) {
  const [hour1, minute1] = time1.split(':').map(Number);
  const [hour2, minute2] = time2.split(':').map(Number);
  if (hour1 > hour2) {
    return true;
  } else return hour1 === hour2 && minute1 > minute2;
}

export const getBase64 = (img: RcFile, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

export const beforeUpload = (file: RcFile) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
  if (!isJpgOrPng) {
    // message.error('You can only upload JPG/PNG file!');
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    // message.error('Image must smaller than 2MB!');
  }
  return isJpgOrPng && isLt2M;
};
export function getCookie(cname: string) {
  let name = cname + '=';
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

export function removeCookie(name: string) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
export function removeEmpty(obj: object) {
  if (obj?.['addresses'])
    obj['addresses'] = obj?.['addresses'].filter((address) => {
      return Object.values(address).some(
        (value) => value !== undefined && value !== null && value !== '',
      );
    });

  if (obj?.['phones'])
    obj['phones'] = obj?.['phones'].filter((address) => {
      return Object.values(address).some(
        (value) => value !== undefined && value !== null && value !== '',
      );
    });
  if (obj?.['children_dependents'])
    obj['children_dependents'] = obj?.['children_dependents'].filter(
      (address) => {
        return Object.values(address).some(
          (value) => value !== undefined && value !== null && value !== '',
        );
      },
    );

  return Object.fromEntries(
    Object.entries(obj).filter(([_, v]) => v !== undefined),
  );
}
export function diffTime(start, end) {
  start = start.split(':');
  end = end.split(':');
  const startDate = new Date(0, 0, 0, start[0], start[1], 0);
  const endDate = new Date(0, 0, 0, end[0], end[1], 0);
  let diff = endDate.getTime() - startDate.getTime();
  let hours = Math.floor(diff / 1000 / 60 / 60);
  diff -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(diff / 1000 / 60);

  // If using time pickers with 24 hours format, add the below line get exact hours
  if (hours < 0) hours = hours + 24;

  return (
    (hours <= 9 ? '0' : '') + hours + ':' + (minutes <= 9 ? '0' : '') + minutes
  );
}
export function timeBetween(d1: Date | undefined, d2: Date | undefined) {
  const utc1 = Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const utc2 = Date.UTC(d2.getFullYear(), d2.getMonth(), d2.getDate());
  const diffTime = Math.abs(utc2 - utc1);
  return Math.floor(diffTime / (1000 * 60 * 60 * 24));
}
export const merge = (
  a: object[],
  b: object[],
  predicate = (a: object, b: object) => a === b,
) => {
  const c = [...a]; // copy to avoid side effects
  // add all items from B to copy C if they're not already present
  b.forEach((bItem) =>
    c.some((cItem) => predicate(bItem, cItem)) ? null : c.push(bItem),
  );
  return c;
};

export function calculateAge(birthDate) {
  if (!birthDate || isNaN(Date.parse(birthDate))) {
    // Return null or an empty value for invalid or empty birthDate
    return ''; // or return an empty string, depending on your preference
  }

  const currentDate = new Date();
  const birthDateObj = new Date(birthDate);

  let age = currentDate.getFullYear() - birthDateObj.getFullYear();

  if (
    currentDate.getMonth() < birthDateObj.getMonth() ||
    (currentDate.getMonth() === birthDateObj.getMonth() &&
      currentDate.getDate() < birthDateObj.getDate())
  ) {
    age--;
  }

  return age;
}

export function validateMinus(event) {
  if (event.key === '-' || event.key === 'e') {
    event.preventDefault();
    return false;
  }

  if (
    !/^[0-9]$/.test(event.key) &&
    event.key !== '.' &&
    event.key !== 'Backspace' &&
    event.key !== 'Delete' &&
    event.key !== 'ArrowLeft' &&
    event.key !== 'ArrowRight' &&
    event.key !== 'ArrowUp' &&
    event.key !== 'ArrowDown'
  ) {
    event.preventDefault();
  }

  // Ensure only one dot is entered
  if (event.key === '.' && event.target.value.includes('.')) {
    event.preventDefault();
  }

  const inputElement = event.target;
  const currentText = inputElement.value;
  // console.log(event.key);
  if (parseFloat(inputElement) < 0) {
    event.preventDefault();
    return false;
  }
  if (currentText.length >= 5 && event.key !== 'Backspace') {
    event.preventDefault();
    return false;
  }
}
export function validateSpace(event) {
  if (event.key === ' ' ) {
    event.preventDefault();
    return false;
  }

}
export function validateRate(event) {
  if (event.key === '-' || event.key === 'e') {
    event.preventDefault();
    return false;
  }

  const inputElement = event.target;
  const currentText = inputElement.value;
  // console.log(event.key);
  if (parseFloat(inputElement) < 0 || parseFloat(inputElement) > 100) {
    event.preventDefault();
    return false;
  }
  if (currentText.length >= 3 && event.key !== 'Backspace') {
    event.preventDefault();
    return false;
  }
}
export function setCookie(cname: string, cvalue: string) {
  const d = new Date();
  d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
export const convertString2Obj = (str: string) => {
  return JSON.parse(
    str.replace(/(\w+:)|(\w+ :)/g, function (matchedStr) {
      return '"' + matchedStr.substring(0, matchedStr.length - 1) + '":';
    }),
  );
};
